import React from "react"
import Layout from "../components/layout"
import Form from "../components/form"
import SEO from "../components/seo"
import { FaEnvelope, FaPhone } from "react-icons/fa"

const Contact = () => {
  return (
    <Layout>
      <SEO title="Contact Us" />
      <section className="py-12">
        <div className="grid grid-cols-2 gap-12 items-stretch">
          <div>
            <h1 className="text-4xl mb-2 font-bold">Get in touch</h1>
            <p className="mb-4">
              Drop us a message below and one of our team will get straight in
              touch.
            </p>
            <Form />
          </div>
          <img
            alt="Beautiful home with recently cleaned windows"
            className="w-full object-cover object-center"
            src="https://images.ctfassets.net/yiask8i661w8/1SHDAqm8F6Z4RumP9QskRd/dff708ba87bd86545de6091d33b9754b/hero.jpeg"
          />
        </div>
      </section>
      <section className="py-12 bg-sjh-pale breakout">
        <div className="breakout-inner">
          <h1 className="text-3xl mb-6 font-bold">
            ...Or speak to a team member
          </h1>
          <div className="flex text-2xl mb-4 items-center">
            <FaEnvelope className="mr-3 inline-block" />{" "}
            <a href="mailto:info@sjhcleaning.co.uk">
              <h3>info@sjhcleaning.co.uk</h3>
            </a>
          </div>
          <div className="flex text-2xl items-center">
            <FaPhone className="mr-3 inline-block" />{" "}
            <a href="tel:07989 202460">
              <h3>07989 202460</h3>
            </a>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Contact
